import { render, staticRenderFns } from "./CompanyDescription.vue?vue&type=template&id=2db5e1a8"
import script from "./CompanyDescription.vue?vue&type=script&lang=js"
export * from "./CompanyDescription.vue?vue&type=script&lang=js"
import style0 from "./CompanyDescription.vue?vue&type=style&index=0&id=2db5e1a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports